<template>
  <div class="flex" id="connection-wrapper" v-if="card_left && card_right">
    <div>
      <div class="card connect-card">
        <Markdown
          :source="card_left.front"
          :class="{
            'normal-text': card_left.front.length > 100,
            'align-left': card_left.front.length > 100,
          }"
        />
        <small class="link"  @click="jumpToCard(card_left)">Edit</small>
      </div>
    </div>

    <div id="connection-message-wrapper">
      <h2>Define how these cards are connected:</h2>
      <button @click="getRandomNotes" class="button small-button">
        Can't think of a connection
      </button>

      <textarea
        v-model="connectionMessage"
        class="textarea-standalone"
      ></textarea>

      <!-- disable if connectionMessage is empty  -->
      <button
        @click="saveConnection"
        class="button button-primary"
        :disabled="!connectionMessage"
      >
        Save Connection
      </button>
    </div>

    <div>
      <div class="card connect-card">
        <Markdown
          :source="card_right.front"
          :class="{
            'normal-text': card_right.front.length > 100,
            'align-left': card_right.front.length > 100,
          }"
        />
        <small class="link"  @click="jumpToCard(card_right)">Edit</small>
      </div>
    </div>
  </div>
</template>

<script>
import { supabase } from "../supabase";
import Markdown from "vue3-markdown-it";
import { v4 as uuidv4 } from "uuid";

export default {
  data() {
    return {
      card_left: {
        front: "loading...",
      },
      card_right: {
        front: "loading...",
      },
      collectionsFilterClean: [],
      connectionMessage: "",
    };
  },
  components: {
    Markdown,
  },
  mounted: async function () {
    try {
      const { data, error } = await supabase
        .from("packs")
        .select("id, name")
        .match({ user_id: supabase.auth.currentUser.id, isDisabled: false });
      if (error) throw error;
      this.collectionsFilterClean = data.map((collection) => collection.id);
    } catch (error) {}
    this.getRandomNotes();
  },
  methods: {
    jumpToCard: function (card) {
      this.$store.dispatch("setCurrentEditCardId", card.id).then(() => {
        this.$store.dispatch("setCurrentPackId", card.pack_id).then(() => {
          this.$router.push("/collection");
        });
      });
    },
    async saveConnection() {
      // save connection message as a new card of type 'standard'
      // with the front being the connection message
      try {
        const connectionCardId = uuidv4();
        const { data, error } = await supabase.from("cards").insert([
          {
            id: connectionCardId,
            front: this.connectionMessage,
            back: "connection",
            type: "standard",
            user_id: supabase.auth.currentUser.id,
            pack_id: this.card_left.pack_id,
            nextShown: new Date() / 1000,
          },
        ]);
        if (error) throw error;

        // create connections from this to both cards, with the scheme of:

        const { data: data2, error: error2 } = await supabase
          .from("card_connections")
          .insert([
            {
              card_sender: this.card_left.id,
              card_receiver: connectionCardId,
              front_sender: this.card_left.front,
              front_receiver: this.connectionMessage,
            },
            {
              card_sender: this.card_right.id,
              card_receiver: connectionCardId,
              front_sender: this.card_right.front,
              front_receiver: this.connectionMessage,
            },
          ]);
        if (error2) throw error2;

        this.getRandomNotes();
        this.connectionMessage = "";
      } catch (error) {}
    },
    async getRandomNotes() {
      try {
        const { data: id, error } = await supabase.rpc(
          "get_random_card_with_type_filter",
          {
            id_of_user: supabase.auth.currentUser.id,
            type_filter: ["standard"],
            collections_filter: this.collectionsFilterClean,
            due: new Date() / 1000,
          }
        );
        if (error) throw error;
        const id_left = id[0].id;
        const { data: noteData, error: noteError } = await supabase
          .from("cards")
          .select("id, front, back, pack_id")
          .eq("id", id_left)
          .single();
        if (noteError) {
        }
        this.card_left = noteData;

        const { data: id2, error: error2 } = await supabase.rpc(
          "get_random_card_with_type_filter",
          {
            id_of_user: supabase.auth.currentUser.id,
            type_filter: ["standard"],
            collections_filter: this.collectionsFilterClean,
            due: new Date() / 1000,
          }
        );
        if (error2) throw error2;
        const id_right = id2[0].id;
        const { data: noteData2, error: noteError2 } = await supabase
          .from("cards")
          .select("id, front, back")
          .eq("id", id_right)
          .single();
        if (noteError2) {
        }
        this.card_right = noteData2;
      } catch (error) {}
    },
  },
  computed: {},
};
</script>
